import React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@/elements/shared/Card/Card';
import { PLACEHOLDER_IMAGES, PRODUCT_IMAGES } from '../mockData';
import styles from './StyleGuideCards.module.css';

const IMG = PRODUCT_IMAGES.badgeScanner;
const IMG_GRAY = PLACEHOLDER_IMAGES.gray;

/**
 * Card Types tab — mirrors Figma "Card / Types" (node-id: 3:2927).
 */
export const StyleGuideCardTypes: React.FC = observer(function StyleGuideCardTypes() {
  return (
    <div className={styles.section}>
      {/* VERTICAL */}
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Vertical</h2>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Image & text</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateCardVerticalTall}>
              <Card orientation="vertical" label="Badge Scanner" imageSrc={IMG} value="type-img-text" />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Color & text</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateCardVerticalTall}>
              <Card orientation="vertical" label="Badge Scanner" imageSrc={IMG_GRAY} value="type-color-text" />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Text only</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateItem}>
              <div className={styles.stateCardVertical}>
                <Card orientation="vertical" label="Badge Scanner" value="type-text-only" imageSrc={undefined} />
              </div>
            </div>
            <div className={styles.stateItem}>
              <div className={styles.stateCardVerticalTall}>
                <Card
                  orientation="vertical"
                  label="Badge Scanner"
                  description="for access tickets (Z-fold)"
                  cost="145,00 $"
                  value="type-text-expanded"
                  imageSrc={undefined}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Image only</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateCardVertical}>
              <Card orientation="vertical" imageSrc={IMG} value="type-img-only" />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Color only</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateCardVertical}>
              <Card orientation="vertical" imageSrc={IMG_GRAY} value="type-color-only-1" />
            </div>
            <div className={styles.stateCardVertical}>
              <Card orientation="vertical" imageSrc={IMG_GRAY} value="type-color-only-2" />
            </div>
            <div className={styles.stateCardVertical}>
              <Card orientation="vertical" imageSrc={IMG_GRAY} value="type-color-only-3" />
            </div>
          </div>
        </div>
      </div>

      {/* HORIZONTAL */}
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Horizontal</h2>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Image & text</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateCardHorizontal}>
              <Card orientation="horizontal" label="Badge Scanner" imageSrc={IMG} value="type-h-img-text" />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Color & text</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateCardHorizontal}>
              <Card orientation="horizontal" label="Badge Scanner" imageSrc={IMG_GRAY} value="type-h-color-text" />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDemo}>
        <h3 className={styles.cardDemoTitle}>Text only</h3>
        <div className={styles.demo}>
          <div className={styles.stateGrid}>
            <div className={styles.stateItem}>
              <div className={styles.stateCardHorizontalCompact}>
                <Card orientation="horizontal" label="Badge Scanner" value="type-h-text-only" imageSrc={undefined} />
              </div>
            </div>
            <div className={styles.stateItem}>
              <div className={styles.stateCardHorizontal}>
                <Card
                  orientation="horizontal"
                  label="Badge Scanner"
                  description="for access tickets (Z-fold)"
                  cost="145,00 $"
                  value="type-h-text-expanded"
                  imageSrc={undefined}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
